import React, { useState, useEffect } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { RenderByCargo } from "utils/RenderByCargo";
import { getCheckAutonomo } from "screens/perfilAutonomo/api/getCheckAutonomo";
import { CARGO_CODES } from "constants/permissions";
import axiosLead from "../../services/lead";
import { AuthState } from "../../store/ducks/auth/types";
import Indicators from "./components/indicators";
import ModalNotifications from "./components/modalNotifications";
import SectionBirthdays from "./components/sectionBirthdays";
import SectionTasks from "./components/sectionTasks";
import SectionManagementTasks from "./components/sectionManagementTasks";

import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import * as IconsSVG from "../../assets/iconsSVG";
import * as Styles from "./styles";
import WantToDoCard from "./components/wantToDoCard";

const DashBoard = () => {
  const { name, codigoCargo2013, username } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const [notificationCount, setNotificationCount] = useState<number>(0);
  const [modalNotifications, setModalNotifications] = useState<boolean>(false);
  const [cards, setCards] = useState<any>([]);
  const [cardsReaded, setCardsReaded] = useState<any>([]);
  const [totalItensRetorno, setTotalItensRetorno] = useState<number>(10);
  const [loadingNotifications, setLoadingNotifications] =
    useState<boolean>(false);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);

  const isAutonomo = localStorage.getItem("isAutonomo");
  const isGestorTarefas =
    codigoCargo2013 === CARGO_CODES.GERENTE_VENDAS ||
    codigoCargo2013 === CARGO_CODES.GERENTE_CIA ||
    codigoCargo2013 === CARGO_CODES.GERENTE_GERAL ||
    codigoCargo2013 === CARGO_CODES.SUPERINTENDENTE ||
    codigoCargo2013 === CARGO_CODES.DIRETOR;

  useEffect(() => {
    if (isAutonomo === null) {
      getCheckAutonomo(username);
    }
  }, [isAutonomo]);

  useEffect(() => {
    requestNotifications();
  }, [totalItensRetorno, modalNotifications]);

  const requestNotifications = async () => {
    setLoadingNotifications(true);
    const params = {
      TotalItensRetorno: totalItensRetorno,
      AtualizaNotificacaoLida: modalNotifications,
    };
    try {
      const response = await axiosLead.GetNotifications(params);
      setCardsReaded(response?.data?.data[0]?.notificacoesVisualizadas);
      setCards(response?.data?.data[0]?.notificacoesNaoVisualizadas);
      setNotificationCount(
        response?.data?.data[0]?.quantidadeNotificacoesNaoVisualizadas
      );
    } catch (error) {
      console.error(error);
    }
    setLoadingNotifications(false);
  };

  return (
    <Styles.HomeContainer>
      <Styles.HeaderContainer>
        <Styles.WelcomeText>
          <span>Olá</span>, {name}
          <span className="exclamation">!</span>
        </Styles.WelcomeText>
        <Styles.Notification
          onClick={() => setModalNotifications(!modalNotifications)}
        >
          <IconsSVG.NotificationIcon />
          {notificationCount > 0 && (
            <Styles.NotificationCounter>
              {notificationCount}
            </Styles.NotificationCounter>
          )}
        </Styles.Notification>
      </Styles.HeaderContainer>
      <Styles.ContentContainer>
        <Styles.SectionContent>
          <WantToDoCard />
          <Indicators codigoCargo2013={codigoCargo2013} />
          <SectionBirthdays codigoCargo2013={codigoCargo2013} />
        </Styles.SectionContent>
        {isGestorTarefas ? (
          <SectionManagementTasks />
        ) : (
          <RenderByCargo
            cargo={codigoCargo2013}
            isCorretor={<SectionTasks />}
          />
        )}
      </Styles.ContentContainer>
      <ModalNotifications
        className={`open-${modalNotifications}`}
        setModalNotifications={setModalNotifications}
        cards={cards}
        cardsReaded={cardsReaded}
        setTotalItensRetorno={setTotalItensRetorno}
        totalItensRetorno={totalItensRetorno}
        loading={loadingNotifications}
        firstLoad={firstLoad}
        setFirstLoad={setFirstLoad}
      />
    </Styles.HomeContainer>
  );
};
export default DashBoard;
